<template>
  <div class="flex-grow-1">
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-12">
        </div>
      </div>
      <div class="row">
        <div class="col companies-container">
          <div
            class="small-box company-tile bg-brand"
            v-for="company in companies"
            :key="company.uuid"
          >
            <div class="inner">
              <h4 class="text-truncate">{{ company.full_name }}</h4>
              <p class="text-truncate text-white-50">
                P.IVA: {{ company.vat_id }}<br/>
                N° Email: {{ company.accounts_count }}
              </p>
            </div>
            <div class="icon">
              <i class="fas fa-building"></i>
            </div>
            <div class="container-fluid">
              <div class="row">
                <router-link
                  :to="{ name: 'dashboard', params: { company: company.id } }"
                  class="col company-link btn text-white"
                >
                  <span style="display: inline-block;"
                    ><i class="fas fa-envelope"></i
                  ></span>
                  <span class="row company-link-description"
                        >Posta elettronica</span
                      >
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, inject } from 'vue';
import useSettingsStore from "@/stores/settings.store.js";
import * as companyService from '@/services/company.service.js';

const settingsStore = useSettingsStore()
const tryAsync = inject('tryAsync');

const companies = ref([]);

async function init() {
  settingsStore.setTitle('Aziende')
  settingsStore.setSubtitle("Seleziona un'azienda");

  companies.value = await tryAsync(
    companyService.getAll(),
    "Errore nel richiedere le aziende"
  );
}

init();
</script>

<style lang="scss" scoped>
.companies-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.companies-container .company-tile {
  width: 350px;
}
</style>
